import React, { useState } from 'react';
import Navbar from '../../../components/navbar';
import Footer from '../../../components/footer';
import { FaArrowLeft, FaSearch } from 'react-icons/fa';
import { useLocation } from 'react-router-dom'
import { useFirestore } from '../../../hooks/useFirestore';
import { useAlert } from '../../../contexts/alerta';
import MostraStatus from '../../../components/mostraStatus';
import InputFile from '../../../components/inputFile';
import MostraMotivo from '../../../components/mostraMotivo';
import { mensagemAtualizaRelato } from '../../../hooks/useEmail';

export default function RelatoEsp() {
  const [resposta, setResposta] = useState({
    mensagem: '',
    respondidoPor: '',
    respondidoEm: ''
  })

  const { atualizaRelato } = useFirestore()
  const location = useLocation()
  const { addAlert } = useAlert()

  const relato = location.state.relato

  const handleInput = (value) => {
    setResposta({ ...resposta, mensagem: value })
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    if (relato.nome !== '') {
      resposta.respondidoPor = relato.nome
      resposta.respondidoEm = new Date().getTime()
    }

    if (relato.msg === undefined) {
      relato.msg = []
      relato.msg.push(resposta)
    } else {
      relato.msg.push(resposta)
    }

    atualizaRelato(relato)
      .then(() => {
        mensagemAtualizaRelato({ idRelato: relato.uuid })
        addAlert('¡Mensaje enviado exitosamente!', "success")
      })
      .catch(() => addAlert('¡Ha ocurrido un problema inesperado!', "error"))
  }

  const handleAddAnexo = (anexo) => {
    relato.anexos.push(anexo)
  }

  return (
    <div>
      <Navbar lang={'esp'} />
      <main className='flex mt-40 flex-col'>
        <section className='lg:w-4/6 md:w-5/6 w-11/12 m-auto'>
          <div className='flex justify-between mb-8'>
            <h1 className='flex text-primary items-center text-3xl gap-4 font-semibold uppercase'><FaSearch />SEGUIR SU REPORTE</h1>
            <a className='flex items-center text-base text-secondary gap-2 font-semibold' href="/es/consultar">
              <FaArrowLeft />
              <span className='hidden lg:block'>VOLVER</span>
            </a>
          </div>
          <hr className='border-background mb-8' />
          <div className='text-secondary flex flex-col gap-4'>
            <div className="flex justify-between items-center flex-col lg:flex-row gap-4">
              <span>Número de protocolo: <b>{relato.uuid}</b></span>
              <span className='flex items-center'><b>STATUS:</b> <MostraStatus status={relato.status} lang={'es'}/></span>
            </div>
            <div className='flex justify-between flex-col gap-4 lg:flex-row'>
              <span>Abierto en <b>{new Date(relato.criadoEm).toLocaleString()}</b></span>
              <span>Actualizado en <b>{new Date(relato.alteradoEm).toLocaleString()}</b></span>
              <span>Expira en <b>{new Date(relato.expiraEm).toLocaleString()}</b></span>
            </div>
            {
              relato.nome !== '' &&
              <div className="flex justify-between flex-col gap-4 lg:flex-row">
                <span>Nombre: <b>{relato.nome}</b></span>
                <span>Correo Electronico: <b>{relato.email}</b></span>
                <span>Teléfono: <b>{relato.telefone}</b></span>
              </div>
            }
            <div className="flex flex-col gap-1 mt-2">
              <div className='flex capitalize gap-1 text-primary' style={{ width: '35%' }}>Razón:
                <span id='motivo' name='motivo'><b><MostraMotivo motivo={relato.motivo} lang={'es'}/></b></span>
              </div>
              <div className='flex p-4 flex-col bg-background'>
                Detallando:
                <span id='relato' name='relato'><b>{relato.relato}</b></span>
              </div>
            </div>
            {
              relato.anexos !== undefined &&
              <div className="flex flex-col gap-4">
                <span className='font-semibold text-xl text-primary'>archivos adjuntos:</span>
                {
                  relato.anexos.map((anexo, i) => {
                    return <a href={anexo} key={i} download className='font-semibold underline'>
                      archivo {i + 1}
                    </a>
                  })
                }
              </div>
            }
          </div>
          {
            relato.msg !== undefined && relato.msg.length > 0 ?
              <>
                {relato.msg.map((msg, i) => {
                  return (
                    <div className="bg-background mt-4 mb-4 p-4 text-secondary" key={i}>
                      <span><i>Por: {msg.respondidoPor} - {new Date(msg.respondidoEm).toLocaleString()}</i></span>
                      <p><b>{msg.mensagem}</b></p>
                    </div>
                  )
                })}
                <hr />
              </>
              :
              <></>
          }
          <div className='mt-8'>
            <h1 className='text-primary text-xl font-semibold'>PUEDES PUBLICAR UNA RESPUESTA</h1>
            <h3 className='text-secondary text-lg font-semibold'>
              COMPLETA LA INFORMACIÓN</h3>
            <form onSubmit={handleSubmit} className='flex flex-col gap-8 p-8 my-8 bg-background rounded-md text-secondary'>
              <textarea className='w-full mb-4 p-2 rounded-md outline-primary' name="resposta" id="resposta" rows="5" onChange={e => handleInput(e.target.value)}></textarea>
              <div className="">'
                <p><b>archivos adjuntos</b></p>
                <p>* Extensiones possibleis: jpg,jpeg,png.</p>
                <p>** Tamanho máximo 5MB</p>
              </div>
              <InputFile name={'anexo1'} label={'anexar arquivo'} change={handleAddAnexo} />
              <InputFile name={'anexo2'} label={'anexar arquivo'} change={handleAddAnexo} />
              <InputFile name={'anexo3'} label={'anexar arquivo'} change={handleAddAnexo} />
              <div className='flex justify-end'>
                <input
                  type="submit"
                  value="ENVIA"
                  className={`bg-secondary text-white w-full lg:w-3/12 px-8 py-4 mt-8 rounded-md font-semibold ${resposta.mensagem === '' ? 'hover:cursor-not-allowed' : ' hover:bg-primary hover:cursor-pointer'}`}
                  disabled={resposta.mensagem === ''}
                  title={resposta.mensagem === '' ? 'Mensagem está em branco.' : ''}
                />
              </div>
            </form>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  )
};
